import { t, useLocale } from "@/i18n/locale";
import { X } from "lucide-react";
import { SORT_LABELS } from "./DiscoveryFilters";
import type { DiscoverySort } from "./types";

/**
 * The search and order applied to the Grid, from the URL (#742, #747). On
 * phones the header search collapses once a search is confirmed, so this row
 * is what shows the list is narrowed and how to undo it. It renders nothing
 * for the default list. Categories already show as pressed chips above.
 */
export default function DiscoveryAppliedFilters({ query, sort, onClearQuery, onClearSort }: {
  query: string;
  sort: DiscoverySort;
  onClearQuery: () => void;
  onClearSort: () => void;
}) {
  useLocale();
  if (!query && sort === "recommended") return null;
  const sortLabel = t(SORT_LABELS[sort]);
  return (
    <div className="discovery-applied" role="group" aria-label={t("Applied filters")}>
      {query ? (
        <span className="discovery-applied-chip">
          <span className="discovery-applied-text">{t("Search: {{value0}}", { value0: query })}</span>
          <button type="button" className="discovery-applied-remove" onClick={onClearQuery}
            aria-label={t("Remove search “{{value0}}”", { value0: query })}>
            <X size={14} aria-hidden="true" />
          </button>
        </span>
      ) : null}
      {sort !== "recommended" ? (
        <span className="discovery-applied-chip">
          <span className="discovery-applied-text">{t("Sort: {{value0}}", { value0: sortLabel })}</span>
          <button type="button" className="discovery-applied-remove" onClick={onClearSort}
            aria-label={t("Reset sort to {{value0}}", { value0: t(SORT_LABELS.recommended) })}>
            <X size={14} aria-hidden="true" />
          </button>
        </span>
      ) : null}
    </div>
  );
}
